// extracted by mini-css-extract-plugin
module.exports = {"key-id":"_2BVL0NiBUX","keyId":"_2BVL0NiBUX","right-tag-group":"_35oTd-rahV","rightTagGroup":"_35oTd-rahV","right-tag":"Gl74TiR15t","rightTag":"Gl74TiR15t"};
    if(module.hot) {
      // 1597843259259
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  